import contentTopHeader from '@/components/contentTopHeader'
import dashboardNav from '@/components/dashboardnav'
import chart from 'vue-apexcharts'
import analyticsModal from '@/views/analyticsModal'

export default {
  components: {
    contentTopHeader,
    dashboardNav,
    chart,
    analyticsModal,
  },
  data() {
    return {
      testcount: 0,
      activeTab: 'music',
      activeInnerTab: 'earnings',
      activeChart: '',
      selectedInnerTab: {},
      selectedChart: {},
      daysFilter: 0,
      dashboardStats: [],
      tabs: [
        { id: 'music', title: 'Audio' },
        // { id: 'products', title: 'Products' },
        { id: 'topCreators', title: 'Top Creators' },
      ],
      innerTabs: [
        {
          parent: 'overview',
          tabs: [
            {
              id: 'earnings',
              title: 'Earnings',
              value: 1000,
              size: 'custom',
              breakdown: [
                {
                  title: 'All',
                  value: 'all',
                  series: [{
                    name: 'series-1',
                    data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0],
                  }],
                },
                {
                  title: 'Sales',
                  value: 'sales',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
                {
                  title: 'Donations',
                  value: 'donations',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0],
                  }],
                },
                {
                  title: 'Repost Request',
                  value: 'repostRequest',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
              ],
            },
            {
              id: 'followers',
              title: 'Followers',
              value: 2000,
              size: 'custom',
              breakdown: [
                {
                  title: 'All',
                  value: 'all',
                  series: [{
                    name: 'series-1',
                    data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0],
                  }],
                },
                {
                  title: 'Sales',
                  value: 'sales',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
                {
                  title: 'Donations',
                  value: 'donations',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0],
                  }],
                },
                {
                  title: 'Repost Request',
                  value: 'repostRequest',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
              ],
            },
            {
              id: 'shares',
              title: 'Shares',
              value: 3000,
              size: 'custom',
              breakdown: [
                {
                  title: 'All',
                  value: 'all',
                  series: [{
                    name: 'series-1',
                    data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0],
                  }],
                },
                {
                  title: 'Sales',
                  value: 'sales',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
                {
                  title: 'Donations',
                  value: 'donations',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0],
                  }],
                },
                {
                  title: 'Repost Request',
                  value: 'repostRequest',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
              ],
            },
            {
              id: 'comments',
              title: 'Comments',
              value: 4000,
              size: 'custom',
              breakdown: [
                {
                  title: 'All',
                  value: 'all',
                  series: [{
                    name: 'series-1',
                    data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0],
                  }],
                },
                {
                  title: 'Sales',
                  value: 'sales',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
                {
                  title: 'Donations',
                  value: 'donations',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0],
                  }],
                },
                {
                  title: 'Repost Request',
                  value: 'repostRequest',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
              ],
            },
            {
              id: 'reposts',
              title: 'Reposts',
              value: 5000,
              size: 'custom',
              breakdown: [
                {
                  title: 'All',
                  value: 'all',
                  series: [{
                    name: 'series-1',
                    data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0],
                  }],
                },
                {
                  title: 'Sales',
                  value: 'sales',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
                {
                  title: 'Donations',
                  value: 'donations',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0],
                  }],
                },
                {
                  title: 'Repost Request',
                  value: 'repostRequest',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
              ],
            },
            {
              id: 'subscriptionRevenue',
              title: 'Subscription Revenue',
              value: 6000,
              size: 4,
              breakdown: [
                {
                  title: 'All',
                  value: 'all',
                  series: [{
                    name: 'series-1',
                    data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0],
                  }],
                },
                {
                  title: 'Sales',
                  value: 'sales',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
                {
                  title: 'Donations',
                  value: 'donations',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0],
                  }],
                },
                {
                  title: 'Repost Request',
                  value: 'repostRequest',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
              ],
            },
            {
              id: 'subscribersList',
              title: 'Subscribers List',
              value: 7000,
              size: 4,
              breakdown: [
                {
                  title: 'All',
                  value: 'all',
                  series: [{
                    name: 'series-1',
                    data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0],
                  }],
                },
                {
                  title: 'Sales',
                  value: 'sales',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
                {
                  title: 'Donations',
                  value: 'donations',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0],
                  }],
                },
                {
                  title: 'Repost Request',
                  value: 'repostRequest',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
              ],
            },
            {
              id: 'adRevenue',
              title: 'Ad Revenue',
              value: 8000,
              size: 4,
              breakdown: [
                {
                  title: 'All',
                  value: 'all',
                  series: [{
                    name: 'series-1',
                    data: [0, 10, 45, 50, 80, 60, 70, 45, 10, 0, 0, 0],
                  }],
                },
                {
                  title: 'Sales',
                  value: 'sales',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
                {
                  title: 'Donations',
                  value: 'donations',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 45, 50, 70, 81, 49, 60, 0, 0],
                  }],
                },
                {
                  title: 'Repost Request',
                  value: 'repostRequest',
                  series: [{
                    name: 'series-1',
                    data: [30, 40, 0, 50, 49, 60, 70, 81, 0, 0, 0, 0],
                  }],
                },
              ],
            },
          ],
        },
        {
          parent: 'music',
          header: 'Plays',
          tabs: [
            { id: 1, title: "TOTAL PLAYS", value: "1,110,2938", size: 3 },
            { id: 2, title: "TOTAL STREAMING REVENUE", value: "$51,420.00", size: 3 },
            { id: 3, title: "YOUR STREAMING REVENUE", value: "$4,222", size: 3 },
            { id: 4, title: "TOTAL COLLABORATOR REVENUE", value: "$1,110,2938", size: 3 },
          ],
          statsList: {
            title: "Tracks",
            count: 323,
            items_type: 'musics',
            items: [
              {
                "id": 999,
                "slug": "the-show-rush",
                "name": "The show Rush",
                "user": {
                  "id": 999,
                  "slug": "testartist1",
                  "username": "testartist1",
                  "display_name": "Hudson Mohawke",
                  "user_type": "artist",
                  "avatar": {
                    "url": "../../../static/images/artist.png",
                    "thumb": {
                      "url": "../../../static/images/artist.png",
                    },
                  },
                },
                "album": {
                  "id": 999,
                  "name": "Album Name",
                  "slug": "album-name",
                  "cover": {
                    "url": "../../../static/images/album.jpg",
                    "large": {
                      "url": "../../../static/images/album.jpg",
                    },
                  },
                  "album_type": "album",
                },
              },
            ],
          },
        },
        /*
        {
          parent: 'products',
          tabs: [
            { id: 1, title: "TOTAL SALES", value: "1,110,2938", size: 3 },
            { id: 2, title: "TOTAL SALES REVENUE", value: "$51,420.00", size: 3 },
            { id: 3, title: "YOUR TOTAL SALES REVENUE", value: "$4,222", size: 3 },
            { id: 4, title: "TOTAL COLLABORATOR REVENUE", value: "$1,110,2938", size: 3 },
          ],
          statsList: {
            title: "Products",
            count: 323,
            items_type: 'products',
            items: [
              {
                "id": 999,
                "name": "Cap",
                "description": "Black Cap",
                "cover": {
                    "url": "../../../static/images/product1.png",
                },
                "user": {
                    "id": 999,
                    "slug": "testartist1",
                    "username": "testartist1",
                    "display_name": "Hudson Mohawke",
                    "user_type": "artist",
                    "avatar": {
                        "url": "../../../static/images/artist.png",
                        "thumb": {
                            "url": "../../../static/images/artist.png",
                        },
                    },
                },
              },
            ],
          },
        },
        */
        {
          parent: 'topCreators',
          tabs: [],
        },
      ],
      tabFilterOptions: [
        {
          title: 'All Time', value: 0,
        },
        {
          title: 'Today', value: 1,
        },
        {
          title: 'Month', value: 2,
        },
        {
          title: 'Year', value: 3,
        },
      ],
      chartOptions: {
        colors: ["#5f78ff"],
        chart: {
          type: 'area',
          id: 'own-id',
          foreColor: '#eee',
          zoom: {
            enabled: false,
          },

          toolbar: {
            show: false,
          },
        },
        xaxis: {
          type: 'category',
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
      },
      pieSeries: [44, 55, 41, 17, 15],
      pieChartOptions: {
        chart: {
          type: 'donut',
        },
        labels: ["Country A", "Country B", "Country C", "Country D", "Country E"],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 100,
            },
            legend: {
              position: 'bottom',
            },
          },
        }],
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: !false,
          position: 'bottom',
        },
        plotOptions: {
          pie: {
            customScale: 0.7,
            donut: {
              size: '80%',
            },
          },
        },
      },
      summaryTabs: [
        {
          parent: 'overview',
          colTabs: [
            {
              header: 'TOTAL PLAYS',
              avatarType: 'square',
              data: [],
            },
            {
              header: 'TOTAL STREAMING REVENUE',
              avatarType: 'square',
              data: [],
            },
          ],
        },
        {
          parent: 'music',
          colTabs: [
            {
              header: 'Top albums',
              avatarType: 'square',
              data: [],
            },
            {
              header: 'Top listeners',
              avatarType: 'round',
              data: [],
            },
          ],
          dataTables: [
            {
              headers: [
                {
                  text: 'External Traffic Source',
                  align: 'left',
                  sortable: false,
                  value: 'name',
                },
                {
                  text: 'Visits',
                  align: 'left',
                  sortable: false,
                  value: 'visits',
                },
                {
                  text: 'New Visitors',
                  align: 'left',
                  sortable: false,
                  value: 'newVisitors',
                },
                {
                  text: 'Album Page Visited',
                  align: 'left',
                  sortable: false,
                  value: 'videoPageVisited',
                },
              ],
              data: [
                {
                  name: 'google.com',
                  visits: 159000,
                  newVisitors: '40%',
                  albumPageVisited: '1000',
                },
                {
                  name: 'google.com',
                  visits: 237000,
                  newVisitors: '40%',
                  albumPageVisited: '1000',
                },
                {
                  name: 'google.com',
                  visits: 262000,
                  newVisitors: '60%',
                  albumPageVisited: '7000',
                },
                {
                  name: 'google.com',
                  visits: 305000,
                  newVisitors: '40%',
                  albumPageVisited: '8000',
                },
                {
                  name: 'google.com',
                  visits: 356000,
                  newVisitors: '30%',
                  albumPageVisited: '16000',
                },
                {
                  name: 'google.com',
                  visits: 375000,
                  newVisitors: '00%',
                  albumPageVisited: '0000',
                },
                {
                  name: 'google.com',
                  visits: 392000,
                  newVisitors: '100%',
                  albumPageVisited: '2000',
                },
                {
                  name: 'google.com',
                  visits: 408000,
                  newVisitors: '60%',
                  albumPageVisited: '45000',
                },
                {
                  name: 'google.com',
                  visits: 452000,
                  newVisitors: '40%',
                  albumPageVisited: '22000',
                },
                {
                  name: 'google.com',
                  visits: 518000,
                  newVisitors: '10%',
                  albumPageVisited: '6000',
                },
              ],
            },
          ],
        },
        {
          parent: 'videos',
          colTabs: [
            {
              header: 'Top Videos',
              avatarType: 'rectangle',
              data: [],
            },
            {
              header: 'Plays by Countries',
              type: 'pie',
              data: [],
            },
            {
              header: 'Top Viewers',
              avatarType: 'round',
              data: [],
            },
          ],
          dataTables: [
            {
              headers: [
                {
                  text: 'External Traffic Source',
                  align: 'left',
                  sortable: false,
                  value: 'name',
                },
                {
                  text: 'Visits',
                  align: 'left',
                  sortable: false,
                  value: 'visits',
                },
                {
                  text: 'New Visitors',
                  align: 'left',
                  sortable: false,
                  value: 'newVisitors',
                },
                {
                  text: 'Product Page Visited',
                  align: 'left',
                  sortable: false,
                  value: 'videoPageVisited',
                },
              ],
              data: [
                {
                  name: 'google.com',
                  visits: 159000,
                  newVisitors: '40%',
                  albumPageVisited: '1000',
                },
                {
                  name: 'google.com',
                  visits: 237000,
                  newVisitors: '40%',
                  albumPageVisited: '1000',
                },
                {
                  name: 'google.com',
                  visits: 262000,
                  newVisitors: '60%',
                  albumPageVisited: '7000',
                },
                {
                  name: 'google.com',
                  visits: 305000,
                  newVisitors: '40%',
                  albumPageVisited: '8000',
                },
                {
                  name: 'google.com',
                  visits: 356000,
                  newVisitors: '30%',
                  albumPageVisited: '16000',
                },
                {
                  name: 'google.com',
                  visits: 375000,
                  newVisitors: '00%',
                  albumPageVisited: '0000',
                },
                {
                  name: 'google.com',
                  visits: 392000,
                  newVisitors: '100%',
                  albumPageVisited: '2000',
                },
                {
                  name: 'google.com',
                  visits: 408000,
                  newVisitors: '60%',
                  albumPageVisited: '45000',
                },
                {
                  name: 'google.com',
                  visits: 452000,
                  newVisitors: '40%',
                  albumPageVisited: '22000',
                },
                {
                  name: 'google.com',
                  visits: 518000,
                  newVisitors: '10%',
                  albumPageVisited: '6000',
                },
              ],
            },
          ],
        },
        /*
        {
          parent: 'products',
          colTabs: [
            {
              header: 'Top Products',
              data: [],
            },
            {
              header: 'Top Customers',
              avatarType: 'round',
              data: [],
            },
          ],
          dataTables: [
            {
              headers: [
                {
                  text: 'External Traffic Source',
                  align: 'left',
                  sortable: false,
                  value: 'name',
                },
                {
                  text: 'Visits',
                  align: 'left',
                  sortable: false,
                  value: 'visits',
                },
                {
                  text: 'New Visitors',
                  align: 'left',
                  sortable: false,
                  value: 'newVisitors',
                },
                {
                  text: 'Product Page Visited',
                  align: 'left',
                  sortable: false,
                  value: 'videoPageVisited',
                },
              ],
              data: [
                {
                  name: 'google.com',
                  visits: 159000,
                  newVisitors: '40%',
                  albumPageVisited: '1000',
                },
                {
                  name: 'google.com',
                  visits: 237000,
                  newVisitors: '40%',
                  albumPageVisited: '1000',
                },
                {
                  name: 'google.com',
                  visits: 262000,
                  newVisitors: '60%',
                  albumPageVisited: '7000',
                },
                {
                  name: 'google.com',
                  visits: 305000,
                  newVisitors: '40%',
                  albumPageVisited: '8000',
                },
                {
                  name: 'google.com',
                  visits: 356000,
                  newVisitors: '30%',
                  albumPageVisited: '16000',
                },
                {
                  name: 'google.com',
                  visits: 375000,
                  newVisitors: '00%',
                  albumPageVisited: '0000',
                },
                {
                  name: 'google.com',
                  visits: 392000,
                  newVisitors: '100%',
                  albumPageVisited: '2000',
                },
                {
                  name: 'google.com',
                  visits: 408000,
                  newVisitors: '60%',
                  albumPageVisited: '45000',
                },
                {
                  name: 'google.com',
                  visits: 452000,
                  newVisitors: '40%',
                  albumPageVisited: '22000',
                },
                {
                  name: 'google.com',
                  visits: 518000,
                  newVisitors: '10%',
                  albumPageVisited: '6000',
                },
              ],
            },
          ],
        },
        */
        {
          parent: 'topCreators',
          colTabs: null,
          dataTables: [
            {
              title: 'Top Creators',
              headers: [
                {
                  text: 'Creator',
                  align: 'left',
                  sortable: false,
                  value: 'name',
                },
                {
                  text: 'Plays',
                  align: 'left',
                  sortable: false,
                  value: 'plays',
                },
                {
                  text: 'Earnings',
                  align: 'left',
                  sortable: false,
                  value: 'earnings',
                },
              ],
              data: [
                {
                  name: 'Hudson Mohawke',
                  plays: '234 plays',
                  earnings: '$0.50',
                  avatar: '../../../static/images/artist.png',
                },
                // Add more creators here as needed
              ],
            },
          ],
        },
      ],
      totalTrackList: [
        { id: 1, title: "PLAYS", content: "1,110" },
        { id: 2, title: "TOTAL REVENUE", content: "$51,420.00" },
        { id: 3, title: "YOUR SALES REVENUE", content: "$4,222" },
        { id: 4, title: "COLLABORATOR REVENUE", content: "$1,000" },
      ],
    }
  },

  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser() {
      return this.$store.state.auth.user
    },
    showChartHeader() {
      return ['overview', 'products']
    },
  },

  watch: {
    activeTab(val) {
      // find and select first index of breakdown on menu change
      const inner = this.innerTabs.find((inner) => inner.parent === val)
      console.log(inner);
      const action = inner.tabs[0]

      this.activeInnerTab = action.id
      if (action.breakdown) {
        this.selectedChart = action.breakdown[0] || null
        this.activeChart = action.breakdown[0].value
      } else {
        this.selectedChart = action.breakdown
        this.activeChart = 'all'
      }
      this.setChartDetails(action)
    },
  },

  methods: {
    isActiveTab(tab) {
      return this.activeTab === tab
    },
    isActiveInnerTab(tab) {
      return this.activeInnerTab === tab
    },
    isActiveChart(tab) {
      return this.activeChart === tab
    },
    setTopMenu(filter) {
      const selected = this.tabs.find((f) => f.id === filter)
      this.activeTab = selected.id
    },
    getInnerTab() {
      const inner = this.innerTabs.find((inner) => inner.parent === this.activeTab)
      return inner.tabs
    },
    getStatsList() {
      const inner = this.innerTabs.find((inner) => inner.parent === this.activeTab)
      return inner.statsList
    },
    setActiveChart(tab) {
      this.selectedChart = tab
      if (tab == null) return
      this.activeChart = tab.value
    },
    setChartDetails(action) {
      if (action){
      this.activeInnerTab = action.id
      this.selectedInnerTab = action

      // For Menus that do not have further inner tab selection
      if (this.showChartHeader.indexOf(this.activeTab) < 0) {
        // Just select first item in breakdown series
        if (action.breakdown) {
          this.setActiveChart(action.breakdown[0])
        } else {
          this.setActiveChart(action.breakdown)
        }
      }
    }
    },
    getSummaryTabs() {
      const tab = this.activeTab
      const col = this.summaryTabs.find((col) => col.parent === tab)

      return col.colTabs || null
    },
    getDataTables() {
      const tab = this.activeTab
      const col = this.summaryTabs.find((col) => col.parent === tab)

      return col.dataTables || null
    },
  },

  async created() {
    const innerTab = this.getInnerTab()
    const initSelection = innerTab.find((f) => f.id === this.activeInnerTab)
    this.setChartDetails(initSelection)

    // this.selectedChart = this.selectedInnerTab.breakdown[0]
    // this.activeChart = this.selectedInnerTab.breakdown[0].value
  },
  mounted() {
    if (this.currentUser.plan !== "pro") {
      this.tabs = []
    }
    window.dispatchEvent(new Event('resize'))

    setTimeout(()=>{
      $(".nav-z-index").removeClass("white");
    }, 0)
  },
}



// WEBPACK FOOTER //
// ./src/views/dashboard/dashboard.ctrl.js